import { FormBlock, TypeBlock, TypeElement } from '@entities/Filter/module/types/filterElementsSchema';
import { General } from '@entities/Filter/module/types/filterSchema';
import { ProductSpecifications, SeasonEnum, TornEnum } from '@entities/Product';

export const mockDataTyres: FormBlock[] = [
  {
    blockId: 1,
    sort: 400,
    title: 'Цена за шт.',
    type: TypeBlock.PriceBlock,
    disabled: false,
    elements: [
      {
        type: TypeElement.RangeInputs,
        name: 'price_range',
        sort: 100,
        settings: {
          maxPrice: 162270,
          minPrice: 0,
          priceGap: 1000,
        },
        disabled: false,
      },
    ],
  },
  {
    blockId: 2,
    sort: 100,
    title: 'Размер',
    type: TypeBlock.TyresSelects,
    disabled: false,
    elements: [
      {
        type: TypeElement.Select,
        title: 'Ширина',
        name: ProductSpecifications.TyresWidth,
        sort: 100,
        defaultValue: null,
        isInfoTooltip: true,
        nullState: 'Все',
        disabled: false,
        settings: [],
        options: [
          {
            title: '7',
            value: 7,
            sort: 0,
          },
          {
            title: '7.5',
            value: 7.5,
            sort: 0,
          },
          {
            title: '27',
            value: 27,
            sort: 0,
          },
          {
            title: '28',
            value: 28,
            sort: 0,
          },
          {
            title: '30',
            value: 30,
            sort: 0,
          },
          {
            title: '31',
            value: 31,
            sort: 0,
          },
          {
            title: '32',
            value: 32,
            sort: 0,
          },
          {
            title: '33',
            value: 33,
            sort: 0,
          },
          {
            title: '35',
            value: 35,
            sort: 0,
          },
          {
            title: '37',
            value: 37,
            sort: 0,
          },
          {
            title: '39',
            value: 39,
            sort: 0,
          },
          {
            title: '40',
            value: 40,
            sort: 0,
          },
          {
            title: '135',
            value: 135,
            sort: 0,
          },
          {
            title: '145',
            value: 145,
            sort: 0,
          },
          {
            title: '155',
            value: 155,
            sort: 0,
          },
          {
            title: '165',
            value: 165,
            sort: 0,
          },
          {
            title: '175',
            value: 175,
            sort: 0,
          },
          {
            title: '185',
            value: 185,
            sort: 0,
          },
          {
            title: '195',
            value: 195,
            sort: 0,
          },
          {
            title: '205',
            value: 205,
            sort: 0,
          },
          {
            title: '225',
            value: 225,
            sort: 0,
          },
          {
            title: '235',
            value: 235,
            sort: 0,
          },
          {
            title: '245',
            value: 245,
            sort: 0,
          },
          {
            title: '255',
            value: 255,
            sort: 0,
          },
          {
            title: '265',
            value: 265,
            sort: 0,
          },
          {
            title: '275',
            value: 275,
            sort: 0,
          },
          {
            title: '285',
            value: 285,
            sort: 0,
          },
          {
            title: '295',
            value: 295,
            sort: 0,
          },
          {
            title: '305',
            value: 305,
            sort: 0,
          },
          {
            title: '315',
            value: 315,
            sort: 0,
          },
          {
            title: '325',
            value: 325,
            sort: 0,
          },
          {
            title: '335',
            value: 335,
            sort: 0,
          },
          {
            title: '345',
            value: 345,
            sort: 0,
          },
          {
            title: '355',
            value: 355,
            sort: 0,
          },
        ],
      },
      {
        type: TypeElement.Select,
        title: 'Высота',
        name: ProductSpecifications.TyresProfile,
        sort: 200,
        isInfoTooltip: true,
        defaultValue: null,
        nullState: 'Все',
        disabled: false,
        settings: [],
        options: [
          {
            title: '8.5',
            value: '8.5',
            sort: 0,
          },
          {
            title: '9.5',
            value: '9.5',
            sort: 0,
          },
          {
            title: '10',
            value: '10',
            sort: 0,
          },
          {
            title: '10.5',
            value: '10.5',
            sort: 0,
          },
          {
            title: '11',
            value: '11',
            sort: 0,
          },
          {
            title: '11.5',
            value: '11.5',
            sort: 0,
          },
          {
            title: '12.5',
            value: '12.5',
            sort: 0,
          },
          {
            title: '13.5',
            value: '13.5',
            sort: 0,
          },
          {
            title: '25',
            value: '25',
            sort: 0,
          },
          {
            title: '30',
            value: '30',
            sort: 0,
          },
          {
            title: '35',
            value: '35',
            sort: 0,
          },
          {
            title: '40',
            value: '40',
            sort: 0,
          },
          {
            title: '45',
            value: '45',
            sort: 0,
          },
          {
            title: '50',
            value: '50',
            sort: 0,
          },
          {
            title: '55',
            value: '55',
            sort: 0,
          },
          {
            title: '60',
            value: '60',
            sort: 0,
          },
          {
            title: '65',
            value: '65',
            sort: 0,
          },
          {
            title: '70',
            value: '70',
            sort: 0,
          },
          {
            title: '75',
            value: '75',
            sort: 0,
          },
          {
            title: '80',
            value: '80',
            sort: 0,
          },
          {
            title: '85',
            value: '85',
            sort: 0,
          },
          {
            title: '90',
            value: '90',
            sort: 0,
          },
          {
            title: '100',
            value: '100',
            sort: 0,
          },
        ],
      },
      {
        type: TypeElement.Select,
        title: 'Диаметр',
        name: ProductSpecifications.TyresDiameter,
        sort: 300,
        isInfoTooltip: true,
        defaultValue: null,
        nullState: 'Все',
        disabled: false,
        settings: [],
        options: [
          {
            title: '12',
            value: '12',
            sort: 0,
          },
          {
            title: '13',
            value: '13',
            sort: 0,
          },
          {
            title: '14',
            value: '14',
            sort: 0,
          },
          {
            title: '15',
            value: '15',
            sort: 0,
          },
          {
            title: '16',
            value: '16',
            sort: 0,
          },
          {
            title: '17',
            value: '17',
            sort: 0,
          },
          {
            title: '18',
            value: '18',
            sort: 0,
          },
          {
            title: '19',
            value: '19',
            sort: 0,
          },
          {
            title: '20',
            value: '20',
            sort: 0,
          },
          {
            title: '21',
            value: '21',
            sort: 0,
          },
          {
            title: '22',
            value: '22',
            sort: 0,
          },
          {
            title: '23',
            value: '23',
            sort: 0,
          },
          {
            title: '24',
            value: '24',
            sort: 0,
          },
        ],
      },
    ],
  },
  {
    blockId: 3,
    sort: 200,
    title: 'sb',
    type: TypeBlock.SeasonBlock,
    disabled: false,
    elements: [
      {
        type: TypeElement.GroupButtons,
        title: 'Сезон',
        name: ProductSpecifications.TyresSeason,
        sort: 100,
        defaultValue: null,
        disabled: false,
        settings: [],
        options: [
          {
            title: 'Все',
            value: null,
            sort: 100,
          },
          {
            title: 'Лето',
            value: SeasonEnum.Summer,
            sort: 200,
          },
          {
            title: 'Зима',
            value: SeasonEnum.Winter,
            sort: 300,
          },
        ],
      },
      {
        type: TypeElement.GroupButtons,
        title: 'Шипы',
        name: ProductSpecifications.TyresThorn,
        sort: 200,
        defaultValue: null,
        disabled: false,
        settings: [],
        options: [
          {
            title: 'Все',
            value: null,
            sort: 100,
          },
          {
            title: 'Шипы',
            value: TornEnum.Torn,
            sort: 300,
          },
          {
            title: 'Без шипов',
            value: TornEnum.NoTorn,
            sort: 200,
          },
        ],
      },
    ],
  },
  {
    blockId: 4,
    sort: 300,
    title: null,
    type: TypeBlock.BrandBlock,
    disabled: false,
    elements: [
      {
        type: TypeElement.CheckBox,
        title: 'Производитель',
        name: ProductSpecifications.TyresDeveloper,
        sort: 100,
        defaultValue: null,
        disabled: false,
        settings: [],
        options: [
          {
            title: 'Continental',
            value: 'continental',
            sort: 450,
          },
          {
            title: 'Goodyear',
            value: 'goodyear',
            sort: 350,
          },
          {
            title: 'Bridgestone',
            value: 'bridgestone',
            sort: 470,
          },
          {
            title: 'Gislaved',
            value: 'gislaved',
            sort: 370,
          },
          {
            title: 'Волтайр',
            value: 'voltyre',
            sort: 220,
          },
          {
            title: 'КАМА',
            value: 'kama',
            sort: 360,
          },
          {
            title: 'Белшина',
            value: 'belshina',
            sort: 250,
          },
          {
            title: 'Dunlop',
            value: 'dunlop',
            sort: 290,
          },
          {
            title: 'BFGoodrich',
            value: 'bfgoodrich',
            sort: 330,
          },
          {
            title: 'Amtel',
            value: 'amtel',
            sort: 200,
          },
          {
            title: 'Ikon (Nokian Tyres)',
            value: 'ikontyres',
            sort: 480,
          },
          {
            title: 'Sailun',
            value: 'sailun',
            sort: 280,
          },
          {
            title: 'Viatti',
            value: 'viatti',
            sort: 410,
          },
          {
            title: 'Doublestar',
            value: 'doublestar',
            sort: 380,
          },
          {
            title: 'Landsail',
            value: 'landsail',
            sort: 430,
          },
          {
            title: 'Roadstone',
            value: 'roadstone',
            sort: 390,
          },
          {
            title: 'Pirelli',
            value: 'pirelli',
            sort: 500,
          },
          {
            title: 'Kumho',
            value: 'kumho',
            sort: 440,
          },
          {
            title: 'Cordiant',
            value: 'cordiant',
            sort: 460,
          },
          {
            title: 'Triangle',
            value: 'triangle',
            sort: 340,
          },
          {
            title: 'Formula',
            value: 'formula',
            sort: 400,
          },
          {
            title: 'Tunga',
            value: 'tunga',
            sort: 300,
          },
          {
            title: 'Satoya',
            value: 'satoya',
            sort: 270,
          },
          {
            title: 'Yokohama',
            value: 'yokohama',
            sort: 320,
          },
          {
            title: 'Nokian Tyres',
            value: 'nokian',
            sort: 420,
          },
          {
            title: 'MICHELIN',
            value: 'michelin',
            sort: 490,
          },
          {
            title: 'Mirage',
            value: 'mirage',
            sort: 270,
          },
          {
            title: 'Кировский шинный завод',
            value: 'kirovskiy-shinnyiy-zavod',
            sort: 10,
          },
          {
            title: 'Torero',
            value: 'Torero',
            sort: 310,
          },
          {
            title: 'NEREUS',
            value: 'nereus',
            sort: 10,
          },
          {
            title: 'Maxxis',
            value: 'maxxis',
            sort: 40,
          },
          {
            title: 'Hankook',
            value: 'hankook',
            sort: 230,
          },
          {
            title: 'General Tire',
            value: 'general-tire',
            sort: 110,
          },
          {
            title: 'Tigar',
            value: 'tigar',
            sort: 260,
          },
          {
            title: 'Matador',
            value: 'matador',
            sort: 290,
          },
          {
            title: 'FRONWAY',
            value: 'fronway',
            sort: 10,
          },
          {
            title: 'Royal Black',
            value: 'royal-black',
            sort: 10,
          },
          {
            title: 'Roadcruza',
            value: 'roadcruza',
            sort: 10,
          },
          {
            title: 'Greentrac',
            value: 'greentrac',
            sort: 100,
          },
          {
            title: 'Vittos',
            value: 'vittos',
            sort: 10,
          },
          {
            title: 'Laufenn',
            value: 'laufenn',
            sort: 70,
          },
          {
            title: 'TOYO',
            value: 'toyo',
            sort: 250,
          },
          {
            title: 'Sava',
            value: 'sava',
            sort: 260,
          },
          {
            title: 'Nexen',
            value: 'nexen',
            sort: 190,
          },
          {
            title: 'Zmax',
            value: 'zmax',
            sort: 10,
          },
          {
            title: 'Roadking',
            value: 'roadking',
            sort: 10,
          },
          {
            title: 'ILINK',
            value: 'ilink',
            sort: 10,
          },
          {
            title: 'LINGLONG',
            value: 'linglong',
            sort: 10,
          },
          {
            title: 'Antares',
            value: 'antares',
            sort: 100,
          },
          {
            title: 'LEAO',
            value: 'leao',
            sort: 100,
          },
          {
            title: 'Goodride',
            value: 'goodride',
            sort: 10,
          },
          {
            title: 'Tracmax',
            value: 'tracmax',
            sort: 10,
          },
          {
            title: 'Windforce',
            value: 'windforce',
            sort: 100,
          },
          {
            title: 'Contyre',
            value: 'contyre',
            sort: 100,
          },
          {
            title: 'Arivo',
            value: 'arivo',
            sort: 10,
          },
          {
            title: 'Onyx',
            value: 'onyx',
            sort: 10,
          },
          {
            title: 'Imperial',
            value: 'imperial',
            sort: 100,
          },
          {
            title: 'Kormoran',
            value: 'kormoran',
            sort: 80,
          },
          {
            title: 'Hifly',
            value: 'hifly',
            sort: 100,
          },
          {
            title: 'Aplus',
            value: 'aplus',
            sort: 10,
          },
          {
            title: 'GRIPMAX',
            value: 'gripmax',
            sort: 10,
          },
          {
            title: 'Kapsen',
            value: 'kapsen',
            sort: 0,
          },
          {
            title: 'Rotalla',
            value: 'rotalla',
            sort: 10,
          },
          {
            title: 'Roadx',
            value: 'roadx',
            sort: 10,
          },
          {
            title: 'BARS',
            value: 'bars',
            sort: 100,
          },
          {
            title: 'Rapid',
            value: 'rapid',
            sort: 10,
          },
          {
            title: 'West Lake',
            value: 'west-lake',
            sort: 10,
          },
          {
            title: 'Joyroad',
            value: 'joyroad',
            sort: 10,
          },
          {
            title: 'CENTARA',
            value: 'centara',
            sort: 10,
          },
          {
            title: 'HEADWAY',
            value: 'headway',
            sort: 10,
          },
          {
            title: 'Grenlander',
            value: 'grenlander',
            sort: 10,
          },
          {
            title: 'Roadmarch',
            value: 'roadmarch',
            sort: 10,
          },
          {
            title: 'TOURADOR',
            value: 'tourador',
            sort: 10,
          },
          {
            title: 'Zeta',
            value: 'zeta',
            sort: 10,
          },
          {
            title: 'Taurus',
            value: 'taurus',
            sort: 10,
          },
          {
            title: 'Sunfull',
            value: 'sunfull',
            sort: 10,
          },
          {
            title: 'Habilead',
            value: 'habilead',
            sort: 10,
          },
          {
            title: 'Gremax',
            value: 'gremax',
            sort: 0,
          },
          {
            title: 'Forward',
            value: 'forward',
            sort: 10,
          },
          {
            title: 'Boto',
            value: 'boto',
            sort: 10,
          },
          {
            title: 'Nankang ',
            value: 'nankang',
            sort: 40,
          },
          {
            title: 'Torque',
            value: 'torque',
            sort: 10,
          },
          {
            title: 'Falken',
            value: 'falken',
            sort: 120,
          },
          {
            title: 'Marshal',
            value: 'marshal',
            sort: 50,
          },
          {
            title: 'Ovation Tyres',
            value: 'ovation-tyres',
            sort: 30,
          },
          {
            title: 'Ecovision',
            value: 'ecovision',
            sort: 130,
          },
          {
            title: 'DELINTE',
            value: 'delinte',
            sort: 10,
          },
          {
            title: 'Roadboss',
            value: 'roadboss',
            sort: 0,
          },
          {
            title: 'Mileking',
            value: 'mileking',
            sort: 0,
          },
          {
            title: 'RockBlade',
            value: 'rockblade',
            sort: 10,
          },
          {
            title: 'Rydanz',
            value: 'rydanz',
            sort: 10,
          },
          {
            title: 'Compasal',
            value: 'compasal',
            sort: 10,
          },
          {
            title: 'Charmhoo',
            value: 'charmhoo',
            sort: 0,
          },
          {
            title: 'Vredestein',
            value: 'vredestein',
            sort: 10,
          },
          {
            title: 'Tri-Ace',
            value: 'tri-ace',
            sort: 10,
          },
          {
            title: 'Autogreen',
            value: 'autogreen',
            sort: 0,
          },
          {
            title: 'Landspider',
            value: 'landspider',
            sort: 100,
          },
          {
            title: 'Nokian Tyres',
            value: 'nokian-tyres',
            sort: 0,
          },
          {
            title: 'Ikon Tyres',
            value: 'ikon-tyres',
            sort: 0,
          },
          {
            title: 'IKON',
            value: 'ikon',
            sort: 0,
          },
        ],
      },
    ],
  },
  {
    blockId: 5,
    sort: 700,
    title: 'Наличие в центрах',
    disabled: false,
    elements: [
      {
        type: TypeElement.Select,
        title: null,
        name: General.GetShop,
        sort: 100,
        defaultValue: null,
        nullState: 'Все',
        disabled: false,
        settings: [],
        options: [
          {
            title: 'г. Москва, Профсоюзная, 84А, стр. 2, АЗС «Роснефть»',
            value: '17',
            sort: 0,
          },
          {
            title: 'г. Москва, Нахимовский проспект, 24А, АЗС «Роснефть»',
            value: '18',
            sort: 0,
          },
          {
            title: 'МО, Балашиха, шоссе Энтузиастов, 84',
            value: '19',
            sort: 0,
          },
          {
            title: 'МО, Подольск, Правды, 40',
            value: '21',
            sort: 0,
          },
          {
            title: 'г. Москва, Куликовская, 20, стр. 1',
            value: '33',
            sort: 0,
          },
          {
            title: 'МО, Мытищи, Олимпийский проспект, 31А',
            value: '40',
            sort: 0,
          },
          {
            title: 'г. Москва, Волгоградский проспект, 24, стр. 1, АЗС «Роснефть»',
            value: '41',
            sort: 0,
          },
          {
            title: 'г. Москва, Волоколамское шоссе, 79, АЗС «Роснефть»',
            value: '42',
            sort: 0,
          },
          {
            title: 'МО, Красногорск, Знаменская, 9, АЗС «Роснефть»',
            value: '82',
            sort: 0,
          },
          {
            title: 'г. Москва, Декабристов, 49Б, АЗС «Роснефть»',
            value: '83',
            sort: 0,
          },
          {
            title: 'г. Москва, 62-й км МКАД, вл. 7, АЗС «Роснефть»',
            value: '85',
            sort: 0,
          },
          {
            title: 'г. Москва, Верейская, 7, стр. 2',
            value: '87',
            sort: 0,
          },
          {
            title: 'г. Москва, Зеленоград, 4801, д. 3, АЗС «Роснефть»',
            value: '88',
            sort: 0,
          },
          {
            title: 'г. Москва, Академика Королева, 12А, АЗС «Роснефть»',
            value: '89',
            sort: 0,
          },
          {
            title: 'г. Москва, Люблинская, 92, АЗС «Роснефть»',
            value: '90',
            sort: 0,
          },
          {
            title: 'г. Москва, Героев Панфиловцев, 26',
            value: '91',
            sort: 0,
          },
          {
            title: 'г. Москва, Проспект Мира, вл94с1В, АЗС «Роснефть»',
            value: '92',
            sort: 0,
          },
          {
            title: 'г. Москва, Рязанский проспект, д.26 корп.2, АЗС «Роснефть»',
            value: '93',
            sort: 0,
          },
          {
            title: 'г. Москва, Щелковское шоссе, 2/1,  АЗС «Роснефть»',
            value: '94',
            sort: 0,
          },
          {
            title: 'г. Москва, Ясеневая, 13, АЗС «Роснефть»',
            value: '95',
            sort: 0,
          },
          {
            title: 'МО, Балашиха, шоссе Энтузиастов, 1/2',
            value: '97',
            sort: 0,
          },
          {
            title: 'МО, Балашиха, деревня Черное, Агрогородок, вл. 77',
            value: '98',
            sort: 0,
          },
          {
            title: 'МО, Электроугли, Железнодорожная, 29, стр. 1',
            value: '99',
            sort: 0,
          },
          {
            title: 'г. Москва, Айвазовского, 2Ас2, АЗС «Роснефть»',
            value: '161',
            sort: 0,
          },
          {
            title: 'г. Москва, 55-й км МКАД, авторынок ТК «АвтоМОЛЛ»',
            value: '185',
            sort: 0,
          },
          {
            title: 'г. Москва, 80-й км МКАД, авторынок «Тэнек»',
            value: '186',
            sort: 0,
          },
          {
            title: 'г. Москва, Ижорская, 8Б',
            value: '189',
            sort: 0,
          },
          {
            title: 'МО, Ленинградское шоссе, городской округ Химки, деревня Чёрная Грязь, с18М',
            value: '190',
            sort: 0,
          },
          {
            title: 'МО, Балашиха, Щелковское шоссе, 1Б',
            value: '191',
            sort: 0,
          },
          {
            title: 'г. Москва, Северодвинская, 20А',
            value: '192',
            sort: 0,
          },
          {
            title: 'г. Москва, Ленинский проспект, 137А, АЗС «Роснефть»',
            value: '196',
            sort: 0,
          },
          {
            title: 'г. Москва, Можайское шоссе, 43, АЗС «Роснефть»',
            value: '197',
            sort: 0,
          },
          {
            title: 'г. Москва, Тимирязевская, 38А, АЗС «Роснефть»',
            value: '198',
            sort: 0,
          },
          {
            title: 'г. Москва, шоссе Энтузиастов, 63, АЗС «Роснефть»',
            value: '199',
            sort: 0,
          },
          {
            title: 'г. Москва, Ярославское шоссе, 38, стр. 1',
            value: '200',
            sort: 0,
          },
          {
            title: 'МО, Красногорск, Ленина, 5',
            value: '288',
            sort: 0,
          },
          {
            title: 'г. Москва, Маршала Катукова, 1',
            value: '289',
            sort: 0,
          },
          {
            title: 'г. Москва, Щелковское шоссе, 98/57',
            value: '290',
            sort: 0,
          },
          {
            title: 'г. Москва, Зеленоград, 514, стр.  1',
            value: '293',
            sort: 0,
          },
          {
            title: 'г. Москва, Загородное шоссе, 7, корп. 1 (Севастопольский проспект)',
            value: '297',
            sort: 0,
          },
          {
            title: 'г. Москва, Мичуринский проспект, 21, корп. 2',
            value: '298',
            sort: 0,
          },
          {
            title: 'г. Москва, Свободы, 79',
            value: '299',
            sort: 0,
          },
          {
            title: 'г. Москва, Зеленоград, 1812',
            value: '300',
            sort: 0,
          },
          {
            title: 'г. Москва, Пришвина, 2А',
            value: '301',
            sort: 0,
          },
          {
            title: 'г. Москва, Скульптора Мухиной, 13',
            value: '302',
            sort: 0,
          },
          {
            title: 'г. Москва, Шипиловская, 28Г',
            value: '303',
            sort: 0,
          },
          {
            title: 'МО, г. Орехово-Зуево, Малодубенское шоссе, 3',
            value: '315',
            sort: 0,
          },
          {
            title: 'МО, Орехово-Зуево, Малодубенское шоссе, 3',
            value: '333',
            sort: 0,
          },
          {
            title: 'МО, г. Подольск, ул. Правды, д. 40',
            value: '618',
            sort: 0,
          },
          {
            title: 'г. Москва, Новоухтомское шоссе, дом 2А, стр. 3',
            value: '805',
            sort: 0,
          },
          {
            title: 'г. Москва, Щербинка, Симферопольское ш. 7А',
            value: '807',
            sort: 0,
          },
          {
            title: 'МО, Химки, Пожарского, 204-Е УСМР',
            value: '1014',
            sort: 0,
          },
          {
            title: 'г. Москва, Дубравная, д.51, стр. 1 ТЦ "Митино Парк"',
            value: '1226',
            sort: 0,
          },
          {
            title: 'ул. Полины Осипенко, д. 40А',
            value: '1538',
            sort: 0,
          },
          {
            title: 'Осташинская, 51В',
            value: '153',
            sort: 0,
          },
          {
            title: 'Гагарина, 1',
            value: '158',
            sort: 0,
          },
          {
            title: 'поселок Барсуки, ул. Шоссейная, 1А',
            value: '1225',
            sort: 0,
          },
          {
            title: 'Азаровская, 26',
            value: '306',
            sort: 0,
          },
          {
            title: 'Бирюзова, 25',
            value: '454',
            sort: 0,
          },
          {
            title: 'Зерновая, 15Д',
            value: '160',
            sort: 0,
          },
        ],
      },
    ],
  },
  {
    blockId: 6,
    sort: 900,
    title: 'Участие в акциях',
    disabled: false,
    elements: [
      {
        type: TypeElement.Select,
        title: null,
        name: General.ActionType,
        sort: 100,
        defaultValue: null,
        nullState: 'Все',
        disabled: false,
        settings: [],
        options: [
          {
            title: 'Подарок при покупке',
            value: '1',
            sort: 0,
          },
          {
            title: 'Скидка/распродажа',
            value: '2',
            sort: 0,
          },
          {
            title: 'Кэшбэк',
            value: '3',
            sort: 0,
          },
          {
            title: 'Кредит/рассрочка',
            value: '4',
            sort: 0,
          },
          {
            title: 'Бесплатный шиномонтаж ',
            value: '5',
            sort: 0,
          },
        ],
      },
    ],
  },
  {
    blockId: 7,
    sort: 500,
    title: null,
    disabled: false,
    elements: [
      {
        type: TypeElement.CheckBox,
        title: 'Бесплатный шиномонтаж',
        name: ProductSpecifications.TyresBSHM,
        sort: 100,
        isInfoTooltip: true,
        defaultValue: false,
        disabled: false,
        settings: [],
      },
      {
        type: TypeElement.CheckBox,
        title: 'Распродажа',
        name: ProductSpecifications.TyresSaleFlag,
        sort: 200,
        defaultValue: false,
        disabled: false,
        settings: [],
      },
    ],
  },
  {
    blockId: 8,
    sort: 600,
    title: null,
    disabled: false,
    elements: [
      {
        type: TypeElement.Switcher,
        title: 'Комплект (4 шт.)',
        name: ProductSpecifications.TyresHide4,
        sort: 300,
        defaultValue: true,
        disabled: false,
        settings: [],
      },
    ],
  },
  {
    blockId: 9,
    sort: 800,
    title: null,
    disabled: false,
    elements: [
      {
        type: TypeElement.CheckBox,
        title: 'Коммерческие шины',
        name: ProductSpecifications.TyresIsCommercial,
        sort: 200,
        defaultValue: false,
        disabled: false,
        isInfoTooltip: true,
        settings: [],
      },
      {
        type: TypeElement.CheckBox,
        title: 'RunFlat',
        name: ProductSpecifications.TyresRunFlat,
        sort: 400,
        defaultValue: false,
        disabled: false,
        isInfoTooltip: true,
        settings: [],
      },
    ],
  },
];

export const mockDataDisks: FormBlock[] = [
  {
    blockId: 1,
    sort: 100,
    title: 'Размер',
    disabled: false,
    type: TypeBlock.DisksSelects,
    elements: [
      {
        type: TypeElement.Select,
        title: 'Диаметр',
        name: ProductSpecifications.DiscsDiameter,
        sort: 100,
        defaultValue: null,
        isInfoTooltip: true,
        disabled: false,
        nullState: 'Все',
        options: [
          { title: '12', value: '12' },
          { title: '13', value: '13' },
          { title: '14', value: '14' },
          { title: '20', value: '20' },
        ],
      },
      {
        type: TypeElement.Select,
        title: 'Крепление (PCD)',
        name: ProductSpecifications.DiscsPcd,
        sort: 200,
        isInfoTooltip: true,
        defaultValue: null,
        disabled: false,
        nullState: 'Все',
        options: [
          { title: '3*98', value: '3*98' },
          { title: '4*98', value: '4*98' },
          { title: '4*100', value: '4*100' },
          { title: '5*150', value: '5*150' },
        ],
      },
      {
        type: TypeElement.RangeSelects,
        title: 'Центральное отверстие (Dia)',
        name: [ProductSpecifications.MinDiscsDia, ProductSpecifications.MaxDiscsDia],
        sort: 200,
        isInfoTooltip: true,
        defaultValue: null,
        disabled: false,
        nullState: 'Все',
        options: [
          { title: '54.1', value: '54.1' },
          { title: '56.1', value: '56.1' },
          { title: '56.6', value: '56.6' },
          { title: '57.1', value: '57.1' },
          { title: '57.2', value: '57.2' },
          { title: '58.1', value: '58.1' },
          { title: '58.5', value: '58.5' },
          { title: '58.6', value: '58.6' },
          { title: '59.5', value: '59.5' },
          { title: '59.6', value: '59.6' },
          { title: '110.2', value: '110.2' },
        ],
      },
      {
        type: TypeElement.RangeSelects,
        title: 'Вылет (ET)',
        name: [ProductSpecifications.MinDiscsEt, ProductSpecifications.MaxDiscsEt],
        sort: 300,
        isInfoTooltip: true,
        defaultValue: null,
        disabled: false,
        nullState: 'Все',
        options: [
          { title: '-24', value: '-24' },
          { title: '-20', value: '-20' },
          { title: '-15', value: '-15' },
          { title: '-14', value: '-14' },
          { title: '-10', value: '-10' },
          { title: '-5', value: '-5' },
          { title: '-3', value: '-3' },
          { title: '0', value: '0' },
          { title: '5', value: '5' },
          { title: '7', value: '7' },
        ],
      },
      {
        type: TypeElement.RangeSelects,
        title: 'Ширина',
        name: [ProductSpecifications.MinDiscsWidth, ProductSpecifications.MaxDiscsWidth],
        sort: 400,
        isInfoTooltip: true,
        defaultValue: null,
        disabled: false,
        nullState: 'Все',
        options: [
          { title: '4', value: '4' },
          { title: '4.5', value: '4.5' },
          { title: '5', value: '5' },
          { title: '5.5', value: '5.5' },
          { title: '6', value: '6' },
          { title: '6.5', value: '6.5' },
          { title: '6.75', value: '6.75' },
          { title: '7', value: '7' },
          { title: '7.5', value: '7.5' },
          { title: '8', value: '8' },
          { title: '8.5', value: '8.5' },
        ],
      },
    ],
  },
  {
    blockId: 2,
    sort: 200,
    isInfoTooltip: true,
    type: TypeBlock.GroupCheckBoxBlock,
    nameTooltip: ProductSpecifications.DiscsType,
    name: ProductSpecifications.DiscsType,
    disabled: false,
    title: 'Тип дисков',
    elements: [
      {
        type: TypeElement.CheckBox,
        title: 'Литые',
        name: ProductSpecifications.DiscsType,
        value: 'alloy',
        sort: 100,
        disabled: false,
        defaultValue: false,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Штампованные',
        name: 'discs_type',
        value: 'steel',
        sort: 200,
        disabled: false,
        defaultValue: false,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Кованые',
        name: 'discs_type',
        value: 'forged',
        sort: 100,
        disabled: false,
        defaultValue: false,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Грузовые',
        name: 'discs_type',
        value: 'trucks',
        sort: 200,
        disabled: false,
        defaultValue: false,
      },
    ],
  },
  {
    blockId: 3,
    sort: 300,
    title: null,
    type: TypeBlock.BrandBlock,
    disabled: false,
    elements: [
      {
        type: TypeElement.CheckBox,
        title: 'Производитель',
        name: ProductSpecifications.DiscsDeveloper,
        sort: 100,
        disabled: false,
        defaultValue: null,
        options: [
          { title: 'Amtel', value: 'amtel', sort: 1800 },
          { title: 'Antares', value: 'antares', sort: 1900 },
          { title: 'Aplus', value: 'aplus', sort: 2000 },
          { title: 'Bridgestone', value: 'bridgestone', sort: 200 },
          { title: 'Continental', value: 'continental', sort: 400 },
          { title: 'Cooper', value: 'cooper', sort: 1400 },
          { title: 'Dunlop', value: 'dunlop', sort: 600 },
          { title: 'Falken', value: 'falken', sort: 1300 },
          { title: 'Firestone', value: 'firestone', sort: 900 },
          { title: 'Goodyear', value: 'goodyear', sort: 300 },
          { title: 'Hankook', value: 'hankook', sort: 700 },
          { title: 'Kumho', value: 'kumho', sort: 1100 },
          { title: 'Maxxis', value: 'maxxis', sort: 1500 },
          { title: 'Michelin', value: 'michelin', sort: 100 },
          { title: 'Nokian', value: 'nokian', sort: 1000 },
          { title: 'Pirelli', value: 'pirelli', sort: 500 },
          { title: 'Sumitomo', value: 'sumitomo', sort: 1600 },
          { title: 'Toyo', value: 'toyo', sort: 1200 },
          { title: 'Vredestein', value: 'vredestein', sort: 1700 },
          { title: 'Yokohama', value: 'yokohama', sort: 800 },
        ],
      },
    ],
  },
  {
    blockId: 4,
    sort: 400,
    title: 'Цена за шт.',
    type: TypeBlock.PriceBlock,
    disabled: false,
    elements: [
      {
        type: TypeElement.RangeInputs,
        name: 'price_range',
        disabled: false,
        sort: 100,
        settings: {
          minPrice: 0,
          maxPrice: 143480,
          priceGap: 1000,
        },
      },
    ],
  },
  {
    blockId: 5,
    sort: 500,
    title: null,
    disabled: false,
    elements: [
      {
        type: 'checkbox',
        title: 'Распродажа',
        name: ProductSpecifications.DiscsSaleFlag,
        disabled: false,
        sort: 100,
        defaultValue: false,
      },
    ],
  },
  {
    blockId: 6,
    sort: 600,
    title: null,
    disabled: false,
    elements: [
      {
        type: TypeElement.Switcher,
        title: 'Комплект (4 шт.)',
        name: ProductSpecifications.DiscsHide4,
        disabled: false,
        sort: 200,
        defaultValue: false,
      },
    ],
  },
  {
    blockId: 7,
    sort: 700,
    title: 'Наличие в центрах',
    disabled: false,
    elements: [
      {
        type: TypeElement.Select,
        title: null,
        name: General.GetShop,
        disabled: false,
        sort: 100,
        defaultValue: null,
        nullState: 'Все',
        options: [
          {
            title: 'г. Москва, Айвазовского, 2Ас2, АЗС «Роснефть»',
            value: '161',
          },
          {
            title: 'г. Москва, Дубравная, д.51, стр. 1 ТЦ "Митино Парк"',
            value: '1226',
          },
          {
            title: 'г. Москва, Академика Королева, 12А, АЗС «Роснефть»',
            value: '89',
          },
        ],
      },
    ],
  },
  {
    blockId: 8,
    sort: 800,
    title: 'Участие в акциях',
    disabled: false,
    elements: [
      {
        type: TypeElement.Select,
        title: null,
        name: General.ActionType,
        sort: 100,
        defaultValue: null,
        nullState: 'Все',
        disabled: false,
        options: [
          { title: 'Подарок при покупке', value: '1' },
          { title: 'Скидка/распродажа', value: '2' },
          { title: 'Кэшбэк', value: '3' },
        ],
      },
    ],
  },
];

export const mockDataTruckTyres: FormBlock[] = [
  {
    blockId: 1,
    sort: 100,
    title: 'Размер',
    type: TypeBlock.TruckTyresSelects,
    disabled: false,
    elements: [
      {
        type: TypeElement.Select,
        title: 'Ширина',
        name: ProductSpecifications.TruckTyresWidth,
        sort: 100,
        defaultValue: null,
        isInfoTooltip: true,
        disabled: false,
        nullState: 'Все',
        options: [
          { title: '3.5', value: '3.5' },
          { title: '3', value: '3' },
          { title: '4.8', value: '4.8' },
          { title: '215', value: '215' },
          { title: '500', value: '500' },
        ],
      },
      {
        type: TypeElement.Select,
        title: 'Высота',
        name: ProductSpecifications.TruckTyresProfile,
        sort: 200,
        isInfoTooltip: true,
        defaultValue: null,
        nullState: 'Все',
        disabled: false,
        options: [
          { title: '3.5', value: '3.5' },
          { title: '4', value: '4' },
          { title: '5', value: '5' },
          { title: '70', value: '70' },
          { title: '75', value: '75' },
        ],
      },
      {
        type: TypeElement.Select,
        title: 'Диаметр',
        name: ProductSpecifications.TruckTyresDiameter,
        sort: 300,
        isInfoTooltip: true,
        defaultValue: null,
        nullState: 'Все',
        disabled: false,
        options: [
          { title: '4', value: '4' },
          { title: '5', value: '5' },
          { title: '6', value: '6' },
          { title: '17.5', value: '17.5' },
          { title: '20', value: '20' },
        ],
      },
    ],
  },
  {
    blockId: 2,
    sort: 200,
    title: null,
    type: TypeBlock.BrandBlock,
    disabled: false,
    elements: [
      {
        type: TypeElement.CheckBox,
        title: 'Производитель',
        name: ProductSpecifications.TruckTyresDeveloper,
        sort: 100,
        disabled: false,
        defaultValue: null,
        options: [
          { title: 'Amtel', value: 'amtel', sort: 1800 },
          { title: 'Antares', value: 'antares', sort: 1900 },
          { title: 'Aplus', value: 'aplus', sort: 2000 },
          { title: 'Bridgestone', value: 'bridgestone', sort: 200 },
          { title: 'Continental', value: 'continental', sort: 400 },
          { title: 'Cooper', value: 'cooper', sort: 1400 },
          { title: 'Dunlop', value: 'dunlop', sort: 600 },
          { title: 'Falken', value: 'falken', sort: 1300 },
          { title: 'Firestone', value: 'firestone', sort: 900 },
          { title: 'Goodyear', value: 'goodyear', sort: 300 },
          { title: 'Hankook', value: 'hankook', sort: 700 },
          { title: 'Kumho', value: 'kumho', sort: 1100 },
          { title: 'Maxxis', value: 'maxxis', sort: 1500 },
          { title: 'Michelin', value: 'michelin', sort: 100 },
          { title: 'Nokian', value: 'nokian', sort: 1000 },
          { title: 'Pirelli', value: 'pirelli', sort: 500 },
          { title: 'Sumitomo', value: 'sumitomo', sort: 1600 },
          { title: 'Toyo', value: 'toyo', sort: 1200 },
          { title: 'Vredestein', value: 'vredestein', sort: 1700 },
          { title: 'Yokohama', value: 'yokohama', sort: 800 },
        ],
      },
    ],
  },
  {
    blockId: 3,
    sort: 300,
    title: 'Цена за шт.',
    type: TypeBlock.PriceBlock,
    disabled: false,
    elements: [
      {
        type: TypeElement.RangeInputs,
        name: 'price_range',
        sort: 100,
        disabled: false,
        settings: {
          minPrice: 0,
          maxPrice: 143480,
          priceGap: 1000,
        },
      },
    ],
  },
  {
    blockId: 4,
    sort: 400,
    type: TypeBlock.GroupCheckBoxBlock,
    name: ProductSpecifications.TruckTyresUseType,
    title: 'Тип',
    disabled: false,
    elements: [
      {
        type: 'checkbox',
        title: 'Региональная M+S',
        name: ProductSpecifications.TruckTyresUseType,
        value: 1,
        disabled: false,
        sort: 100,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Автобус M+S',
        name: ProductSpecifications.TruckTyresUseType,
        value: 2,
        disabled: false,
        sort: 200,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Региональная',
        name: ProductSpecifications.TruckTyresUseType,
        value: 3,
        disabled: false,
        sort: 300,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Бездорожье M+S',
        name: ProductSpecifications.TruckTyresUseType,
        value: 4,
        disabled: false,
        sort: 400,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Индустриальная',
        name: ProductSpecifications.TruckTyresUseType,
        value: 5,
        disabled: false,
        sort: 500,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Строительная',
        name: ProductSpecifications.TruckTyresUseType,
        value: 6,
        disabled: false,
        sort: 600,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Зимняя',
        name: ProductSpecifications.TruckTyresUseType,
        value: 7,
        disabled: false,
        sort: 700,
      },
      {
        type: TypeElement.CheckBox,
        title: 'M+S',
        name: ProductSpecifications.TruckTyresUseType,
        value: 8,
        disabled: false,
        sort: 800,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Строительная M+S',
        name: ProductSpecifications.TruckTyresUseType,
        value: 9,
        disabled: false,
        sort: 900,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Магистральная M+S',
        name: ProductSpecifications.TruckTyresUseType,
        value: 10,
        disabled: false,
        sort: 1000,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Магистральная',
        name: ProductSpecifications.TruckTyresUseType,
        value: 11,
        disabled: false,
        sort: 1100,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Автобус',
        name: ProductSpecifications.TruckTyresUseType,
        value: 12,
        disabled: false,
        sort: 1200,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Зимняя M+S',
        name: ProductSpecifications.TruckTyresUseType,
        value: 13,
        disabled: false,
        sort: 1300,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Бездорожье',
        name: ProductSpecifications.TruckTyresUseType,
        value: 14,
        disabled: false,
        sort: 1400,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Сельскохозяйственная',
        name: ProductSpecifications.TruckTyresUseType,
        value: 15,
        disabled: false,
        sort: 1500,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Спецтехника',
        name: ProductSpecifications.TruckTyresUseType,
        value: 16,
        disabled: false,
        sort: 1600,
      },
      {
        type: TypeElement.CheckBox,
        title: 'КГШ',
        name: ProductSpecifications.TruckTyresUseType,
        value: 17,
        disabled: false,
        sort: 1700,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Бандажная',
        name: ProductSpecifications.TruckTyresUseType,
        value: 18,
        disabled: false,
        sort: 1800,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Карьерная  M+S',
        name: ProductSpecifications.TruckTyresUseType,
        value: 19,
        disabled: false,
        sort: 1900,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Карьерная',
        name: ProductSpecifications.TruckTyresUseType,
        value: 20,
        disabled: false,
        sort: 2000,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Универсальная',
        name: ProductSpecifications.TruckTyresUseType,
        value: 21,
        disabled: false,
        sort: 2100,
      },
    ],
  },
  {
    blockId: 5,
    sort: 500,
    type: TypeBlock.GroupCheckBoxBlock,
    name: ProductSpecifications.TruckTyresAxle,
    title: 'Назначение',
    disabled: false,
    elements: [
      {
        type: TypeElement.CheckBox,
        title: 'Ведущая',
        name: ProductSpecifications.TruckTyresAxle,
        value: 1,
        disabled: false,
        sort: 100,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Универсальная',
        name: ProductSpecifications.TruckTyresAxle,
        value: 2,
        disabled: false,
        sort: 200,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Прицепная',
        name: ProductSpecifications.TruckTyresAxle,
        value: 3,
        disabled: false,
        sort: 300,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Рулевая',
        name: ProductSpecifications.TruckTyresAxle,
        value: 4,
        disabled: false,
        sort: 400,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Рулевая/ПрицепнаяM+S',
        name: ProductSpecifications.TruckTyresAxle,
        value: 5,
        disabled: false,
        sort: 500,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Пневматическая',
        name: ProductSpecifications.TruckTyresAxle,
        value: 6,
        disabled: false,
        sort: 600,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Рулевая/Прицепная',
        name: ProductSpecifications.TruckTyresAxle,
        value: 7,
        disabled: false,
        sort: 700,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Цельнолитая',
        name: ProductSpecifications.TruckTyresAxle,
        value: 8,
        disabled: false,
        sort: 800,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Рулевая M+S',
        name: ProductSpecifications.TruckTyresAxle,
        value: 9,
        disabled: false,
        sort: 900,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Ведущая M+S',
        name: ProductSpecifications.TruckTyresAxle,
        value: 10,
        disabled: false,
        sort: 1000,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Прицепная M+S',
        name: ProductSpecifications.TruckTyresAxle,
        value: 11,
        disabled: false,
        sort: 1100,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Универсальная M+S',
        name: ProductSpecifications.TruckTyresAxle,
        value: 12,
        disabled: false,
        sort: 1200,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Прицепная 3PSF',
        name: ProductSpecifications.TruckTyresAxle,
        value: 13,
        disabled: false,
        sort: 1300,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Ведущая 3PSF',
        name: ProductSpecifications.TruckTyresAxle,
        value: 14,
        disabled: false,
        sort: 1400,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Рулевая 3PSF',
        name: ProductSpecifications.TruckTyresAxle,
        value: 15,
        disabled: false,
        sort: 1500,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Универсальная ШК',
        name: ProductSpecifications.TruckTyresAxle,
        value: 16,
        disabled: false,
        sort: 1600,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Рулевая CCC',
        name: ProductSpecifications.TruckTyresAxle,
        value: 17,
        disabled: false,
        sort: 1700,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Пневматическая б/к',
        name: ProductSpecifications.TruckTyresAxle,
        value: 18,
        disabled: false,
        sort: 1800,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Пневматическая ш/к',
        name: ProductSpecifications.TruckTyresAxle,
        value: 19,
        disabled: false,
        sort: 1900,
      },
      {
        type: TypeElement.CheckBox,
        title: 'Прицепная  M+S',
        name: ProductSpecifications.TruckTyresAxle,
        value: 20,
        disabled: false,
        sort: 2000,
      },
    ],
  },
  {
    blockId: 6,
    sort: 500,
    title: null,
    disabled: false,
    elements: [
      {
        type: TypeElement.Switcher,
        title: 'Комплект (4 шт.)',
        name: ProductSpecifications.TruckTyresHide4,
        sort: 200,
        disabled: false,
        defaultValue: false,
      },
    ],
  },
];

export const mockDataAkb: FormBlock[] = [
  {
    blockId: 1,
    sort: 100,
    title: 'Ёмкость',
    disabled: false,
    isInfoTooltip: true,
    nameTooltip: ProductSpecifications.AkbCapacity,
    elements: [
      {
        type: TypeElement.Select,
        title: null,
        name: ProductSpecifications.AkbCapacity,
        sort: 100,
        defaultValue: null,
        disabled: false,
        nullState: 'Все',
        options: [
          { title: '5.5', value: '5.5' },
          { title: '10', value: '10' },
          { title: '40', value: '40' },
        ],
      },
    ],
  },
  {
    blockId: 2,
    sort: 200,
    title: 'Полярность',
    disabled: false,
    isInfoTooltip: true,
    nameTooltip: ProductSpecifications.AkbPolarity,
    elements: [
      {
        type: TypeElement.Select,
        title: null,
        disabled: false,
        name: ProductSpecifications.AkbPolarity,
        sort: 100,
        defaultValue: null,
        isInfoTooltip: true,
        nullState: 'Все',
        options: [
          { title: 'Обрат.', value: '0' },
          { title: 'Прям.', value: '1' },
        ],
      },
    ],
  },
  {
    blockId: 3,
    sort: 300,
    title: 'Пусковой ток',
    disabled: false,
    elements: [
      {
        type: TypeElement.Select,
        title: null,
        name: ProductSpecifications.AkbCranking,
        disabled: false,
        sort: 100,
        defaultValue: null,
        nullState: 'Все',
        options: [
          { title: '30', value: '30' },
          { title: '45', value: '45' },
          { title: '50', value: '50' },
        ],
      },
    ],
  },
  {
    blockId: 4,
    sort: 400,
    title: 'Размер (ДхШхВ)',
    disabled: false,
    isInfoTooltip: true,
    nameTooltip: ProductSpecifications.AkbDimensions,
    elements: [
      {
        type: TypeElement.Select,
        title: null,
        name: ProductSpecifications.AkbDimensions,
        isInfoTooltip: true,
        disabled: false,
        sort: 100,
        defaultValue: null,
        nullState: 'Все',
        options: [
          { title: '260x175x225', value: '260x175x225' },
          { title: '242x175x190', value: '242x175x190' },
          { title: '276x175x190', value: '276x175x190' },
        ],
      },
    ],
  },
  {
    blockId: 5,
    sort: 500,
    title: null,
    type: TypeBlock.BrandBlock,
    disabled: false,
    elements: [
      {
        disabled: false,
        type: TypeElement.CheckBox,
        title: 'Производитель',
        name: ProductSpecifications.AkbDeveloper,
        sort: 100,
        defaultValue: null,
        options: [
          { title: 'Amtel', value: 'amtel', sort: 1800 },
          { title: 'Antares', value: 'antares', sort: 1900 },
          { title: 'Aplus', value: 'aplus', sort: 2000 },
          { title: 'Bridgestone', value: 'bridgestone', sort: 200 },
          { title: 'Continental', value: 'continental', sort: 400 },
          { title: 'Taxxon', value: 'taxxon', sort: 1400 },
          { title: 'Dunlop', value: 'dunlop', sort: 600 },
          { title: 'Falken', value: 'falken', sort: 1300 },
          { title: 'Firestone', value: 'firestone', sort: 900 },
          { title: 'Goodyear', value: 'goodyear', sort: 300 },
          { title: 'Hankook', value: 'hankook', sort: 700 },
          { title: 'Kumho', value: 'kumho', sort: 1100 },
          { title: 'Maxxis', value: 'maxxis', sort: 1500 },
          { title: 'Michelin', value: 'michelin', sort: 100 },
          { title: 'Nokian', value: 'nokian', sort: 1000 },
          { title: 'Pirelli', value: 'pirelli', sort: 500 },
          { title: 'Sumitomo', value: 'sumitomo', sort: 1600 },
          { title: 'Toyo', value: 'toyo', sort: 1200 },
          { title: 'Vredestein', value: 'vredestein', sort: 1700 },
          { title: 'Yokohama', value: 'yokohama', sort: 800 },
        ],
      },
    ],
  },
  {
    blockId: 6,
    sort: 600,
    title: 'Цена за шт.',
    type: 'price-block',
    disabled: false,
    elements: [
      {
        disabled: false,
        type: TypeElement.RangeInputs,
        name: 'price_range',
        sort: 100,
        settings: {
          minPrice: 0,
          maxPrice: 143480,
          priceGap: 1000,
        },
      },
    ],
  },
  {
    blockId: 7,
    sort: 700,
    disabled: false,
    title: 'Участие в акциях',
    elements: [
      {
        disabled: false,
        type: TypeElement.Select,
        title: null,
        name: General.ActionType,
        sort: 100,
        defaultValue: null,
        nullState: 'Все',
        options: [
          { title: 'Подарок при покупке', value: '1' },
          { title: 'Скидка/распродажа', value: '2' },
          { title: 'Кэшбэк', value: '3' },
        ],
      },
    ],
  },
];

export const mockDataOils: FormBlock[] = [
  {
    blockId: 1,
    sort: 100,
    title: 'Вязкость',
    disabled: false,
    isInfoTooltip: true,
    nameTooltip: ProductSpecifications.OilViscosity,
    elements: [
      {
        type: TypeElement.Select,
        title: null,
        disabled: false,
        name: ProductSpecifications.OilViscosity,
        sort: 100,
        defaultValue: null,
        isInfoTooltip: null,
        nullState: 'Все',
        options: [
          { title: '10W30', value: '10W30' },
          { title: '10W40', value: '10W40' },
          { title: '10W60', value: '10W60' },
        ],
      },
    ],
  },
  {
    blockId: 2,
    sort: 200,
    title: 'Объем, л',
    disabled: false,
    elements: [
      {
        type: TypeElement.Select,
        title: null,
        disabled: false,
        name: ProductSpecifications.OilVolume,
        sort: 100,
        defaultValue: null,
        isInfoTooltip: null,
        nullState: 'Все',
        options: [
          { title: '1л', value: '1л' },
          { title: '2л', value: '2л' },
          { title: '4л', value: '4л' },
        ],
      },
    ],
  },
  {
    blockId: 3,
    sort: 300,
    title: 'Тип масла',
    disabled: false,
    elements: [
      {
        type: TypeElement.Select,
        title: null,
        disabled: false,
        name: ProductSpecifications.OilType,
        sort: 100,
        defaultValue: null,
        nullState: 'Все',
        options: [
          { title: 'п/синт.', value: '1' },
          { title: 'синт.', value: '2' },
          { title: 'мин.', value: '3' },
          { title: 'мин. с синт. комп.', value: '4' },
        ],
      },
    ],
  },
  {
    blockId: 4,
    sort: 400,
    title: 'Спецификация API',
    disabled: false,
    elements: [
      {
        type: TypeElement.Select,
        title: null,
        disabled: false,
        name: ProductSpecifications.OilApi,
        sort: 100,
        defaultValue: null,
        nullState: 'Все',
        options: [
          { title: 'A3;B4', value: '129' },
          { title: 'CF', value: '12' },
          { title: 'CF;SJ;SL;SM;SN', value: '136' },
        ],
      },
    ],
  },
  {
    blockId: 5,
    sort: 500,
    title: 'Спецификация ACEA',
    disabled: false,
    elements: [
      {
        type: TypeElement.Select,
        title: null,
        disabled: false,
        name: ProductSpecifications.OilAcea,
        sort: 100,
        defaultValue: null,
        nullState: 'Все',
        options: [
          { title: 'A1/B1', value: '4' },
          { title: 'A1/B1;A5/B5;C2', value: '21' },
          { title: 'A1;B1', value: '29' },
        ],
      },
    ],
  },
  {
    blockId: 6,
    sort: 600,
    title: null,
    type: TypeBlock.BrandBlock,
    disabled: false,
    elements: [
      {
        type: TypeElement.CheckBox,
        title: 'Производитель',
        name: ProductSpecifications.OilDeveloper,
        disabled: false,
        sort: 100,
        defaultValue: null,
        options: [
          { title: 'Shell', value: 'shell', sort: 1800 },
          { title: 'Antares', value: 'antares', sort: 1900 },
          { title: 'Aplus', value: 'aplus', sort: 2000 },
          { title: 'Bridgestone', value: 'bridgestone', sort: 200 },
          { title: 'Continental', value: 'continental', sort: 400 },
          { title: 'Cooper', value: 'cooper', sort: 1400 },
          { title: 'Dunlop', value: 'dunlop', sort: 600 },
          { title: 'Falken', value: 'falken', sort: 1300 },
          { title: 'Firestone', value: 'firestone', sort: 900 },
          { title: 'Goodyear', value: 'goodyear', sort: 300 },
          { title: 'Hankook', value: 'hankook', sort: 700 },
          { title: 'Kumho', value: 'kumho', sort: 1100 },
          { title: 'Maxxis', value: 'maxxis', sort: 1500 },
          { title: 'Michelin', value: 'michelin', sort: 100 },
          { title: 'Nokian', value: 'nokian', sort: 1000 },
          { title: 'Pirelli', value: 'pirelli', sort: 500 },
          { title: 'Sumitomo', value: 'sumitomo', sort: 1600 },
          { title: 'Toyo', value: 'toyo', sort: 1200 },
          { title: 'Vredestein', value: 'vredestein', sort: 1700 },
          { title: 'Yokohama', value: 'yokohama', sort: 800 },
        ],
      },
    ],
  },
  {
    blockId: 7,
    sort: 700,
    title: 'Цена за шт.',
    type: TypeBlock.PriceBlock,
    disabled: false,
    elements: [
      {
        type: TypeElement.RangeInputs,
        name: 'price_range',
        disabled: false,
        sort: 100,
        settings: {
          minPrice: 0,
          maxPrice: 143480,
          priceGap: 1000,
        },
      },
    ],
  },
  {
    blockId: 8,
    sort: 800,
    title: 'Участие в акциях',
    disabled: false,
    elements: [
      {
        type: TypeElement.Select,
        title: null,
        disabled: false,
        name: General.ActionType,
        sort: 100,
        defaultValue: null,
        nullState: 'Все',
        options: [
          { title: 'Подарок при покупке', value: '1' },
          { title: 'Скидка/распродажа', value: '2' },
          { title: 'Кэшбэк', value: '3' },
        ],
      },
    ],
  },
];

export const mockDataTyresAuto: FormBlock[] = [
  {
    blockId: 1,
    sort: 100,
    title: null,
    type: TypeBlock.BrandBlock,
    disabled: false,
    elements: [
      {
        disabled: false,
        type: TypeElement.CheckBox,
        title: 'Производитель',
        name: ProductSpecifications.TyresDeveloper,
        sort: 100,
        defaultValue: null,
        options: [
          {
            title: 'Pirelli',
            value: 'pirelli',
            sort: 500,
          },
          {
            title: 'Ikon (Nokian Tyres)',
            value: 'ikontyres',
            sort: 490,
          },
          {
            title: 'Landsail',
            value: 'landsail',
            sort: 480,
          },
          {
            title: 'Armstrong',
            value: 'armstrong',
            sort: 470,
          },
          {
            title: 'Cordiant',
            value: 'cordiant',
            sort: 460,
          },
          {
            title: 'Gislaved',
            value: 'gislaved',
            sort: 450,
          },
          {
            title: 'Kumho',
            value: 'kumho',
            sort: 440,
          },
          {
            title: 'MICHELIN',
            value: 'michelin',
            sort: 430,
          },
          {
            title: 'Bridgestone',
            value: 'bridgestone',
            sort: 420,
          },
          {
            title: 'Continental',
            value: 'continental',
            sort: 410,
          },
          {
            title: 'Nokian Tyres',
            value: 'nokian',
            sort: 400,
          },
          {
            title: 'Viatti',
            value: 'viatti',
            sort: 390,
          },
          {
            title: 'Formula',
            value: 'formula',
            sort: 380,
          },
          {
            title: 'Roadstone',
            value: 'roadstone',
            sort: 370,
          },
          {
            title: 'Doublestar',
            value: 'doublestar',
            sort: 360,
          },
          {
            title: 'КАМА',
            value: 'kama',
            sort: 350,
          },
          {
            title: 'Goodyear',
            value: 'goodyear',
            sort: 340,
          },
          {
            title: 'Triangle',
            value: 'triangle',
            sort: 330,
          },
          {
            title: 'Yokohama',
            value: 'yokohama',
            sort: 320,
          },
          {
            title: 'Torero',
            value: 'Torero',
            sort: 310,
          },
          {
            title: 'Tunga',
            value: 'tunga',
            sort: 300,
          },
          {
            title: 'Dunlop',
            value: 'dunlop',
            sort: 290,
          },
          {
            title: 'Matador',
            value: 'matador',
            sort: 290,
          },
          {
            title: 'BFGoodrich',
            value: 'bfgoodrich',
            sort: 280,
          },
          {
            title: 'Sailun',
            value: 'sailun',
            sort: 280,
          },
          {
            title: 'Mirage',
            value: 'mirage',
            sort: 270,
          },
          {
            title: 'Satoya',
            value: 'satoya',
            sort: 270,
          },
          {
            title: 'Sava',
            value: 'sava',
            sort: 260,
          },
          {
            title: 'Tigar',
            value: 'tigar',
            sort: 260,
          },
          {
            title: 'TOYO',
            value: 'toyo',
            sort: 250,
          },
          {
            title: 'Белшина',
            value: 'belshina',
            sort: 250,
          },
          {
            title: 'Hankook',
            value: 'hankook',
            sort: 230,
          },
          {
            title: 'Волтайр',
            value: 'voltyre',
            sort: 220,
          },
          {
            title: 'Amtel',
            value: 'amtel',
            sort: 200,
          },
          {
            title: 'Nexen',
            value: 'nexen',
            sort: 190,
          },
          {
            title: 'Nitto',
            value: 'nitto',
            sort: 170,
          },
          {
            title: 'Crossleader',
            value: 'crossleader',
            sort: 140,
          },
          {
            title: 'Ecovision',
            value: 'ecovision',
            sort: 130,
          },
          {
            title: 'Falken',
            value: 'falken',
            sort: 120,
          },
          {
            title: 'General Tire',
            value: 'general-tire',
            sort: 110,
          },
          {
            title: 'Antares',
            value: 'antares',
            sort: 100,
          },
          {
            title: 'BARS',
            value: 'bars',
            sort: 100,
          },
          {
            title: 'Contyre',
            value: 'contyre',
            sort: 100,
          },
          {
            title: 'Farroad',
            value: 'farroad',
            sort: 100,
          },
          {
            title: 'Greentrac',
            value: 'greentrac',
            sort: 100,
          },
          {
            title: 'Hifly',
            value: 'hifly',
            sort: 100,
          },
          {
            title: 'Imperial',
            value: 'imperial',
            sort: 100,
          },
          {
            title: 'Landspider',
            value: 'landspider',
            sort: 100,
          },
          {
            title: 'LEAO',
            value: 'leao',
            sort: 100,
          },
          {
            title: 'Windforce',
            value: 'windforce',
            sort: 100,
          },
          {
            title: 'Kormoran',
            value: 'kormoran',
            sort: 80,
          },
          {
            title: 'Laufenn',
            value: 'laufenn',
            sort: 70,
          },
          {
            title: 'Marshal',
            value: 'marshal',
            sort: 50,
          },
          {
            title: 'Maxxis',
            value: 'maxxis',
            sort: 40,
          },
          {
            title: 'Nankang ',
            value: 'nankang',
            sort: 40,
          },
          {
            title: 'Ovation Tyres',
            value: 'ovation-tyres',
            sort: 30,
          },
          {
            title: 'Aplus',
            value: 'aplus',
            sort: 10,
          },
          {
            title: 'Arivo',
            value: 'arivo',
            sort: 10,
          },
          {
            title: 'Autogreen',
            value: 'autogreen',
            sort: 10,
          },
          {
            title: 'Boto',
            value: 'boto',
            sort: 10,
          },
          {
            title: 'CENTARA',
            value: 'centara',
            sort: 10,
          },
          {
            title: 'ChaoYang',
            value: 'chaoyang',
            sort: 10,
          },
          {
            title: 'Compasal',
            value: 'compasal',
            sort: 10,
          },
          {
            title: 'DELINTE',
            value: 'delinte',
            sort: 10,
          },
          {
            title: 'Dynamo',
            value: 'dynamo',
            sort: 10,
          },
          {
            title: 'Evergreen',
            value: 'evergreen',
            sort: 10,
          },
          {
            title: 'Firemax',
            value: 'firemax',
            sort: 10,
          },
          {
            title: 'Forward',
            value: 'forward',
            sort: 10,
          },
          {
            title: 'FRONWAY',
            value: 'fronway',
            sort: 10,
          },
          {
            title: 'Goodride',
            value: 'goodride',
            sort: 10,
          },
          {
            title: 'Gremax',
            value: 'gremax',
            sort: 10,
          },
          {
            title: 'Grenlander',
            value: 'grenlander',
            sort: 10,
          },
          {
            title: 'GRIPMAX',
            value: 'gripmax',
            sort: 10,
          },
          {
            title: 'Habilead',
            value: 'habilead',
            sort: 10,
          },
          {
            title: 'HEADWAY',
            value: 'headway',
            sort: 10,
          },
          {
            title: 'ILINK',
            value: 'ilink',
            sort: 10,
          },
          {
            title: 'Joyroad',
            value: 'joyroad',
            sort: 10,
          },
          {
            title: 'Kapsen',
            value: 'kapsen',
            sort: 10,
          },
          {
            title: 'Kingboss',
            value: 'kingboss',
            sort: 10,
          },
          {
            title: 'LINGLONG',
            value: 'linglong',
            sort: 10,
          },
          {
            title: 'NEREUS',
            value: 'nereus',
            sort: 10,
          },
          {
            title: 'Onyx',
            value: 'onyx',
            sort: 10,
          },
          {
            title: 'Roadboss',
            value: 'roadboss',
            sort: 10,
          },
          {
            title: 'Roadcruza',
            value: 'roadcruza',
            sort: 10,
          },
          {
            title: 'Roadking',
            value: 'roadking',
            sort: 10,
          },
          {
            title: 'Roadmarch',
            value: 'roadmarch',
            sort: 10,
          },
          {
            title: 'Roadx',
            value: 'roadx',
            sort: 10,
          },
          {
            title: 'RockBlade',
            value: 'rockblade',
            sort: 10,
          },
          {
            title: 'Rotalla',
            value: 'rotalla',
            sort: 10,
          },
          {
            title: 'Royal Black',
            value: 'royal-black',
            sort: 10,
          },
          {
            title: 'Starmaxx',
            value: 'starmaxx',
            sort: 10,
          },
          {
            title: 'Sunfull',
            value: 'sunfull',
            sort: 10,
          },
          {
            title: 'Taurus',
            value: 'taurus',
            sort: 10,
          },
          {
            title: 'Torque',
            value: 'torque',
            sort: 10,
          },
          {
            title: 'TOURADOR',
            value: 'tourador',
            sort: 10,
          },
          {
            title: 'Tracmax',
            value: 'tracmax',
            sort: 10,
          },
          {
            title: 'TRAZANO',
            value: 'trazano',
            sort: 10,
          },
          {
            title: 'Tri-Ace',
            value: 'tri-ace',
            sort: 10,
          },
          {
            title: 'Vittos',
            value: 'vittos',
            sort: 10,
          },
          {
            title: 'Vredestein',
            value: 'vredestein',
            sort: 10,
          },
          {
            title: 'West Lake',
            value: 'west-lake',
            sort: 10,
          },
          {
            title: 'Zeta',
            value: 'zeta',
            sort: 10,
          },
          {
            title: 'Zmax',
            value: 'zmax',
            sort: 10,
          },
          {
            title: 'Кировский шинный завод',
            value: 'kirovskiy-shinnyiy-zavod',
            sort: 10,
          },
          {
            title: 'Seamtyre',
            value: 'seamtyre',
            sort: 0,
          },
        ],
      },
    ],
  },
  {
    blockId: 2,
    sort: 200,
    title: null,
    type: TypeBlock.SeasonBlock,
    disabled: false,
    elements: [
      {
        type: TypeElement.GroupButtons,
        title: 'Сезон',
        name: ProductSpecifications.TyresSeason,
        sort: 100,
        defaultValue: null,
        disabled: false,
        settings: [],
        options: [
          {
            title: 'Все',
            value: null,
            sort: 100,
          },
          {
            title: 'Лето',
            value: SeasonEnum.Summer,
            sort: 200,
          },
          {
            title: 'Зима',
            value: SeasonEnum.Winter,
            sort: 300,
          },
        ],
      },
      {
        type: TypeElement.GroupButtons,
        title: 'Шипы',
        name: ProductSpecifications.TyresThorn,
        sort: 200,
        defaultValue: null,
        disabled: false,
        settings: [],
        options: [
          {
            title: 'Все',
            value: null,
            sort: 100,
          },
          {
            title: 'Шипы',
            value: TornEnum.Torn,
            sort: 300,
          },
          {
            title: 'Без шипов',
            value: TornEnum.NoTorn,
            sort: 200,
          },
        ],
      },
    ],
  },
  {
    blockId: 3,
    sort: 300,
    title: null,
    disabled: false,
    elements: [
      {
        disabled: false,
        type: TypeElement.CheckBox,
        title: 'Бесплатный шиномонтаж',
        name: ProductSpecifications.TyresBSHM,
        sort: 100,
        defaultValue: false,
      },
    ],
  },
];

export const mockDataDisksAuto: FormBlock[] = [
  {
    blockId: 3,
    sort: 300,
    title: null,
    type: TypeBlock.BrandBlock,
    disabled: false,
    elements: [
      {
        type: TypeElement.CheckBox,
        title: 'Производитель',
        name: ProductSpecifications.DiscsDeveloper,
        sort: 100,
        disabled: false,
        defaultValue: null,
        options: [
          { title: 'Amtel2', value: 'amtel', sort: 1800 },
          { title: 'Antares', value: 'antares', sort: 1900 },
          { title: 'Aplus', value: 'aplus', sort: 2000 },
          { title: 'Bridgestone', value: 'bridgestone', sort: 200 },
          { title: 'Continental', value: 'continental', sort: 400 },
          { title: 'Cooper', value: 'cooper', sort: 1400 },
          { title: 'Dunlop', value: 'dunlop', sort: 600 },
          { title: 'Falken', value: 'falken', sort: 1300 },
          { title: 'Firestone', value: 'firestone', sort: 900 },
          { title: 'Goodyear', value: 'goodyear', sort: 300 },
          { title: 'Hankook', value: 'hankook', sort: 700 },
          { title: 'Kumho', value: 'kumho', sort: 1100 },
          { title: 'Maxxis', value: 'maxxis', sort: 1500 },
          { title: 'Michelin', value: 'michelin', sort: 100 },
          { title: 'Nokian', value: 'nokian', sort: 1000 },
          { title: 'Pirelli', value: 'pirelli', sort: 500 },
          { title: 'Sumitomo', value: 'sumitomo', sort: 1600 },
          { title: 'Toyo', value: 'toyo', sort: 1200 },
          { title: 'Vredestein', value: 'vredestein', sort: 1700 },
          { title: 'Yokohama', value: 'yokohama', sort: 800 },
        ],
      },
    ],
  },
];

export const mockDataAkbAuto: FormBlock[] = [
  {
    blockId: 5,
    sort: 500,
    title: null,
    type: TypeBlock.BrandBlock,
    disabled: false,
    elements: [
      {
        type: TypeElement.CheckBox,
        title: 'Производитель',
        name: ProductSpecifications.AkbDeveloper,
        sort: 100,
        defaultValue: null,
        disabled: false,
        options: [
          { title: 'Amtel3', value: 'amtel', sort: 1800 },
          { title: 'Antares', value: 'antares', sort: 1900 },
          { title: 'Aplus', value: 'aplus', sort: 2000 },
          { title: 'Bridgestone', value: 'bridgestone', sort: 200 },
          { title: 'Continental', value: 'continental', sort: 400 },
          { title: 'Taxxon', value: 'taxxon', sort: 1400 },
          { title: 'Dunlop', value: 'dunlop', sort: 600 },
          { title: 'Falken', value: 'falken', sort: 1300 },
          { title: 'Firestone', value: 'firestone', sort: 900 },
          { title: 'Goodyear', value: 'goodyear', sort: 300 },
          { title: 'Hankook', value: 'hankook', sort: 700 },
          { title: 'Kumho', value: 'kumho', sort: 1100 },
          { title: 'Maxxis', value: 'maxxis', sort: 1500 },
          { title: 'Michelin', value: 'michelin', sort: 100 },
          { title: 'Nokian', value: 'nokian', sort: 1000 },
          { title: 'Pirelli', value: 'pirelli', sort: 500 },
          { title: 'Sumitomo', value: 'sumitomo', sort: 1600 },
          { title: 'Toyo', value: 'toyo', sort: 1200 },
          { title: 'Vredestein', value: 'vredestein', sort: 1700 },
          { title: 'Yokohama', value: 'yokohama', sort: 800 },
        ],
      },
    ],
  },
];
